const DATAGRID_TYPE = {
    number:  'number',
    boolean: 'boolean',
};

export function buildGridColumns(fields) {
    return fields
        .filter(f => f.showInGrid)
        .sort((a, b) => a.order - b.order)
        .map(field => ({
            field:       field.name,
            headerName:  field.label,
            flex:        field.gridFlex || 1,
            align:       field.gridAlign || 'left',
            headerAlign: field.gridAlign || 'left',
            type:        DATAGRID_TYPE[field.type] || 'string',
            ...(field.type === 'boolean' && {
                renderCell: (params) => (params.value ? 'Yes' : 'No'),
            }),
            ...(field.type === 'date' && {
                renderCell: (params) =>
                    params.value ? new Date(params.value).toLocaleDateString() : '',
            }),
            ...(field.type === 'array' && {
                renderCell: (params) =>
                    Array.isArray(params.value) ? params.value.join(', ') : (params.value || ''),
            }),
            ...(field.type === 'color' && {
                width: 80,
                align: 'center',
                renderCell: (params) => params.value ? (
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', width: '100%', height: '100%' }}>
                        <div style={{ width: 20, height: 20, borderRadius: '50%', backgroundColor: params.value, border: '1px solid rgba(0,0,0,0.23)' }} />
                    </div>
                ) : '',
            }),
        }));
}
